import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { CartProduct } from "../../assets/icons/icons";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
import { Autoplay } from 'swiper/modules';
import axios from "axios";

export default function OffersSection() {
    const { t, i18n } = useTranslation();
    UseScrollAnimation();
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [products, setProducts] = useState([]);

    // Combined useEffect to fetch data once
    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await axios.get("https://laravel-api.aj-mart.com/api/products");
                const filteredProducts = response.data.products.filter(
                    (product) => product.product_price_discount > 0
                );
                // 👇 اعكس الترتيب
                setProducts([...filteredProducts].reverse());
            } catch (error) {
                console.error("Error fetching products:", error);
            }
        };
        fetchProducts();
    }, []);


    // Return localized text based on language
    const getLocalizedText = (key) => {
        const value = i18n.language === 'ar' ? key.A : key.E;
        return value ?? "N/A"; // Fallback to "N/A" if value is undefined
    };

    const renderProduct = (product, index) => {
        if (!product || !product.product_name_E) return null; // Skip rendering if product or product_name_E is missing

        const priceAfterDiscount = (product.product_price * (1 - product.product_price_discount / 100)).toFixed(2);
        const inventoryClass = product.product_stock_available > 0 ? "text-[#18AB00]" : "text-red-500";
        const isHovered = hoveredIndex === index;

        const productName = getLocalizedText({ A: product.product_name_A, E: product.product_name_E });
        const productDesc = getLocalizedText({ A: product.product_desc_A, E: product.product_desc_E });

        // Split description based on language
        const descItems = i18n.language === 'ar' ? productDesc.split('\\ة') : productDesc.split(/\\n|\n/);

        return (
            <SwiperSlide key={product.product_id}>
                <Link
                    to={`/productdetails/${product.product_id}`}
                    className="cursor-pointer flex flex-col w-[300px] h-[500px] rounded-md outline outline-[2px] outline-solid shadow-md relative"
                    style={{ outlineColor: "#eee" }}
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                >
                    <div className="h-[230px] w-full relative">
                        <img
                            className="w-full h-full rounded-t-md object-cover"
                            src={`https://laravel-api.aj-mart.com/storage/app/public/${product.product_main_img}`}
                            alt={productName || "Product Image"}
                        />
                        {product.product_price_discount > 0 && (
                            <div className="w-10 h-10 bg-[#1485a6] rounded-full text-white font-bold flex items-center justify-center absolute top-[10px] right-[10px]">
                                {product.product_price_discount * 1}%
                            </div>
                        )}
                    </div>
                    <div className="h-[2px] bg-[#666666]"></div>
                    <div className="p-[1rem] py-[10px] flex flex-col gap-[10px] p-4 pb-5">
                        <div className="flex items-center justify-between">
                            <div className="text-[22px] font-bold">
                                {productName.length > 50 ? `${productName.substring(0, 50)}...` : productName}
                            </div>
                            <div className="w-[77px] h-[22px] bg-[#0095d5] text-white font-bold rounded-tr-[100px] rounded-bl-[100px] flex items-center justify-center text-[13px]">
                                {t(product.product_status || "Unknown")}
                            </div>
                        </div>
                        <ul className="text-[13px] text-[#666666] list-disc pl-[20px]">
                            {descItems.slice(0, 1).map((desc, idx) => (
                                desc.trim() && (
                                    <li key={idx} className="text-[13px]">
                                        {desc.trim().length > 150 ? `${desc.trim().substring(0, 150)}...` : desc.trim()}
                                    </li>
                                )
                            ))}
                        </ul>
                        <div className="flex justify-between">
                            <div className="flex flex-col gap-[5px]">
                                <span className="font-bold">{priceAfterDiscount} {t("JOD")}</span>
                                <span className="line-through">{product.product_price} {t("JOD")}</span>
                            </div>
                            <div className={`font-bold ${inventoryClass}`}>
                                {t(product.product_stock_available > 0 ? "In Stock" : "Out of Stock")}
                            </div>
                        </div>
                    </div>
                    <Link
                        to={`/productdetails/${product.product_id}`}
                        className={`bg-[#1485a6] flex p-1.5 items-center justify-center gap-1.5 text-white font-bold rounded-tl-[20px] rounded-tr-[20px] absolute bottom-0 left-0 right-0 transition-opacity duration-300 ${isHovered ? "opacity-100" : "opacity-0"}`}
                    >
                        <CartProduct />
                        {t("Add To Cart")}
                    </Link>
                </Link>
            </SwiperSlide>
        );
    };

    return (
        <section className="relative pb-[40px] hidden-over">
            <div className="container">
                <div className="js-scroll fade-top page-title mb-[20px]">
                    {t("News")} <span>{t("Offers")}</span>
                </div>
                <div className="h-auto f-col flex gap-[10px] h-[500px]">
                    <div className="flex flex-col gap-[20px] justify-between">
                        {products.length > 0 && products[0] && (
                            <Link
                                to={`/productdetails/${products[0].product_id}`}
                                className="d-none max-h-auto w-100 w-[826px] f-col flex justify-between border border-[#6666664d] p-5 rounded-md gap-5 max-h-[185px]"
                            >
                                <div className="w-100 w-[40%]">
                                    <img
                                        className="w-full h-full object-contain"
                                        src={`https://laravel-api.aj-mart.com/storage/app/public/${products[0].product_main_img}`}
                                        alt=""
                                    />
                                </div>
                                <div className="flex flex-col gap-[10px]">
                                    <div className="text-[22px] font-bold">
                                        {getLocalizedText({ A: products[0].product_name_A, E: products[0].product_name_E })}
                                    </div>
                                    <ul className="text-[13px] text-[#666666] list-disc pl-[20px]">
                                        {getLocalizedText({ A: products[0].product_desc_A, E: products[0].product_desc_E })
                                            .split(i18n.language === 'ar' ? '\\ة' : /\\n|\n/)
                                            .slice(0, 1)
                                            .map((desc, idx) => (
                                                desc.trim() && (
                                                    <li key={idx} className="text-[13px]">
                                                        {desc.trim().length > 75 ? `${desc.trim().substring(0, 75)}...` : desc.trim()}
                                                    </li>
                                                )
                                            ))}
                                    </ul>
                                    <Link
                                        to={`/productdetails/${products[0].product_id}`}
                                        className="w-fit bg-white py-[0.625rem] px-4 rounded-md text-xs font-bold border border-[#6666664d]"
                                    >
                                        {t("Read More")}
                                    </Link>
                                </div>
                            </Link>
                        )}
                        <div className="flex flex-col gap-[10px]">
                            <div className="flex f-col gap-10 justify-between">
                                {products.length > 1 && products[1] && (
                                    <div className="w-100 offer-1 h-[150px] w-[49%] flex items-center justify-between p-5 rounded-md">
                                        <div className="flex flex-col gap-[10px]">
                                            <div className="font-bold text-[22px] text-white">
                                                {getLocalizedText({ A: products[1].product_name_A, E: products[1].product_name_E })}
                                            </div>
                                            <ul className="text-[13px] text-white list-disc pl-[20px]">
                                                {getLocalizedText({ A: products[1].product_desc_A, E: products[1].product_desc_E })
                                                    .split(i18n.language === 'ar' ? '\\ة' : /\\n|\n/)
                                                    .slice(0, 1)
                                                    .map((desc, idx) => (
                                                        desc.trim() && (
                                                            <li key={idx} className="text-[13px]">
                                                                {desc.trim().length > 50 ? `${desc.trim().substring(0, 50)}...` : desc.trim()}
                                                            </li>
                                                        )
                                                    ))}
                                            </ul>
                                            <Link
                                                to={`/productdetails/${products[1].product_id}`}
                                                className="w-fit bg-white py-[0.625rem] px-4 rounded-md text-xs font-bold"
                                            >
                                                {t("Read More")}
                                            </Link>
                                        </div>
                                        <div className="w-[100px] h-[100px]">
                                            <img
                                                className="w-[100px] h-[100px] object-contain"
                                                src={`https://laravel-api.aj-mart.com/storage/app/public/${products[1].product_main_img}`}
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                )}
                                {products.length > 2 && products[2] && (
                                    <div className="w-100 offer-2 h-[150px] w-[49%] flex items-center justify-between p-5 rounded-md">
                                        <div className="flex flex-col gap-[10px]">
                                            <div className="font-bold text-[22px] text-white">
                                                {getLocalizedText({ A: products[2].product_name_A, E: products[2].product_name_E })}
                                            </div>
                                            <ul className="text-[13px] text-white list-disc pl-[20px]">
                                                {getLocalizedText({ A: products[2].product_desc_A, E: products[2].product_desc_E })
                                                    .split(i18n.language === 'ar' ? '\\ة' : /\\n|\n/)
                                                    .slice(0, 1)
                                                    .map((desc, idx) => (
                                                        desc.trim() && (
                                                            <li key={idx} className="text-[13px]">
                                                                {desc.trim().length > 50 ? `${desc.trim().substring(0, 50)}...` : desc.trim()}
                                                            </li>
                                                        )
                                                    ))}
                                            </ul>
                                            <Link
                                                to={`/productdetails/${products[2].product_id}`}
                                                className="w-fit bg-white py-[0.625rem] px-4 rounded-md text-xs font-bold"
                                            >
                                                {t("Read More")}
                                            </Link>
                                        </div>
                                        <div className="w-[100px] h-[100px]">
                                            <img
                                                className="w-[100px] h-[100px] object-contain"
                                                src={`https://laravel-api.aj-mart.com/storage/app/public/${products[2].product_main_img}`}
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="flex f-col gap-10 justify-between">
                                {products.length > 3 && products[3] && (
                                    <div className="w-100 offer-3 h-[150px] w-[49%] flex items-center justify-between p-5 rounded-md">
                                        <div className="flex flex-col gap-[10px]">
                                            <div className="font-bold text-[22px] text-white">
                                                {getLocalizedText({ A: products[3].product_name_A, E: products[3].product_name_E })}
                                            </div>
                                            <ul className="text-[13px] text-white list-disc pl-[20px]">
                                                {getLocalizedText({ A: products[3].product_desc_A, E: products[3].product_desc_E })
                                                    .split(i18n.language === 'ar' ? '\\ة' : /\\n|\n/)
                                                    .slice(0, 1)
                                                    .map((desc, idx) => (
                                                        desc.trim() && (
                                                            <li key={idx} className="text-[13px]">
                                                                {desc.trim().length > 50 ? `${desc.trim().substring(0, 50)}...` : desc.trim()}
                                                            </li>
                                                        )
                                                    ))}
                                            </ul>
                                            <Link
                                                to={`/productdetails/${products[3].product_id}`}
                                                className="w-fit bg-white py-[0.625rem] px-4 rounded-md text-xs font-bold"
                                            >
                                                {t("Read More")}
                                            </Link>
                                        </div>
                                        <div className="w-[100px] h-[100px]">
                                            <img
                                                className="w-[100px] h-[100px] object-contain"
                                                src={`https://laravel-api.aj-mart.com/storage/app/public/${products[3].product_main_img}`}
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                )}
                                {products.length > 4 && products[4] && (
                                    <div className="w-100 offer-4 h-[150px] w-[49%] flex items-center justify-between p-5 rounded-md">
                                        <div className="flex flex-col gap-[10px]">
                                            <div className="font-bold text-[22px] text-white">
                                                {getLocalizedText({ A: products[4].product_name_A, E: products[4].product_name_E })}
                                            </div>
                                            <ul className="text-[13px] text-white list-disc pl-[20px]">
                                                {getLocalizedText({ A: products[4].product_desc_A, E: products[4].product_desc_E })
                                                    .split(i18n.language === 'ar' ? '\\ة' : /\\n|\n/)
                                                    .slice(0, 1)
                                                    .map((desc, idx) => (
                                                        desc.trim() && (
                                                            <li key={idx} className="text-[13px]">
                                                                {desc.trim().length > 50 ? `${desc.trim().substring(0, 50)}...` : desc.trim()}
                                                            </li>
                                                        )
                                                    ))}
                                            </ul>
                                            <Link
                                                to={`/productdetails/${products[4].product_id}`}
                                                className="w-fit bg-white py-[0.625rem] px-4 rounded-md text-xs font-bold"
                                            >
                                                {t("Read More")}
                                            </Link>
                                        </div>
                                        <div className="w-[100px] h-[100px] ">
                                            <img
                                                className="w-[100px] h-[100px] object-contain "
                                                src={`https://laravel-api.aj-mart.com/storage/app/public/${products[4].product_main_img}`}
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <Swiper
                        modules={[Autoplay]}
                        spaceBetween={20}
                        slidesPerView={1}
                        loop={products.length > 0}
                        pagination={{
                            clickable: true,
                            renderBullet: (index, className) => {
                                return `<span class="${className} custom-dot"></span>`;
                            },
                        }}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            640: { slidesPerView: 1 },
                            768: { slidesPerView: 1 },
                            1024: { slidesPerView: 1 },
                        }}
                        className="pad-20 w-34 direction-ar pad bor-none w-[540px] rounded-[4px] h-[500px] overflow-hidden border border-[#6666664d]"
                    >
                        {products.map((product, index) => renderProduct(product, index))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
}